/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaymentGatesResponse } from '../models/PaymentGatesResponse';
import type { SetPaymentGateSchema } from '../models/SetPaymentGateSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentGatesApi {
    /**
     * Get Payment Gates
     * @returns PaymentGatesResponse OK
     * @throws ApiError
     */
    public static paymentGatesGetPaymentGatesGet({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<PaymentGatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/payment-gates/{company_id}',
            path: {
                'company_id': companyId,
            },
        });
    }
    /**
     * Set Payment Gate
     * @returns any OK
     * @throws ApiError
     */
    public static paymentGatesSetPaymentGatePut({
        companyId,
        requestBody,
    }: {
        companyId: string,
        requestBody: SetPaymentGateSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/payment-gates/{company_id}',
            path: {
                'company_id': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
